<template>
  <div class="page">
    <Header></Header>
    <div class="body">
      <div class="intro-box" style="position: relative;">
        <img src="https://www2.autoimg.cn/oadfs/g33/M00/07/74/Chto52qg-J6AUMBaABf6HDrB6Dg598.jpg" class="intro-banner">
        <div style="position: absolute;bottom:115px;z-index: 99999;text-align: center;width: 100%;display: flex;justify-content: center;font-size: 14px;color: #ffffff;">2027届JIA STAR家速计划校园招聘</div>
        <div style="position: absolute;bottom:59px;z-index: 99999;text-align: center;width: 100%;display: flex;justify-content: center;">
          <div class="intro-pos-btn" @click="gotoDetail('1004')">查看职位</div>
        </div>
      </div>

      <div style="margin-top: 35px; font-family: PingFangSC-Regular;font-size: 16px;color: #111E36;text-align: center;font-weight: 400;">
        面向人群
      </div>
      <div style="margin-top: 8px;text-align: center; font-family: PingFangSC-Regular;font-size: 16px;color: #FF6600;font-weight: 400;">
        <span style="font-family: PingFangSC-Semibold;font-weight: 600;">2027</span>届海内外优秀应届毕业生
      </div>
      <div style="margin-top: 8px;font-family: PingFangSC-Regular;font-size: 12px;color: #111E36;text-align: center;font-weight: 400;">
        国内院校：<span style="font-weight: 600;">2026年9月1日—2027年8月31日</span>毕业
      </div>
      <div style="margin-top: 8px;font-family: PingFangSC-Regular;font-size: 12px;color: #111E36;text-align: center;font-weight: 400;">
        海外院校：<span style="font-weight: 600;">2026年1月1日—2027年12月31日</span>毕业
      </div>
      <div style="margin-top: 8px;margin-left:20px;margin-right:20px;font-family: PingFangSC-Regular;font-size: 12px;color: #111E36;text-align: center;font-weight: 400;">
        国内院校以毕业证为准，海外院校以留服认证为准且最高学历毕业后无全职工作经历
      </div>
      <div style="margin-top: 40px;font-family: PingFangSC-Medium;font-size: 20px;color: #222222;letter-spacing: 0;text-align: center;font-weight: 500;">
        校招流程
      </div>
      <div style="margin-top:8px;font-family: PingFangSC-Regular;font-size: 11px;color: #606266;text-align: center;font-weight: 400;">
        4步加入汽车之家，你的下一个巅峰，在这里启程
      </div>

      <div class="flow-box">
        <div  class="flow-item">
          <img :src="require('@/assets/jianlitoudi.png')" class="flow-item-icon">
          <div class="flow-item-title">投递</div>
<!--          <div class="flow-item-time">9月中开始</div>-->
        </div>
        <div style="position: relative;">
          <img :src="require('@/assets/nextstep2022.png')" class="flow-item-nav-icon">
        </div>
        <div  class="flow-item">
          <img :src="require('@/assets/shaixuan2027.png')" class="flow-item-icon">
          <div class="flow-item-title">筛选</div>
          <!--          <div class="flow-item-time">10月开始</div>-->
        </div>
        <div style="position: relative;">
          <img :src="require('@/assets/nextstep2022.png')" class="flow-item-nav-icon">
        </div>
        <div  class="flow-item">
          <img :src="require('@/assets/mianshi2022.png')" class="flow-item-icon">
          <div class="flow-item-title">面试</div>
<!--          <div class="flow-item-time">10月开始</div>-->
        </div>
        <div style="position: relative;">
          <img :src="require('@/assets/nextstep2022.png')" class="flow-item-nav-icon">
        </div>
        <div  class="flow-item">
          <img :src="require('@/assets/faoffer2022.png')" class="flow-item-icon">
          <div class="flow-item-title">Offer</div>
<!--          <div class="flow-item-time">11月开始</div>-->
        </div>
<!--        <div style="position: relative;">-->
<!--          <img :src="require('@/assets/nextstep2022.png')" class="flow-item-nav-icon">-->
<!--        </div>-->
<!--        <div  class="flow-item">-->
<!--          <img :src="require('@/assets/bishi2022.png')" class="flow-item-icon">-->
<!--          <div class="flow-item-title">实习</div>-->
<!--&lt;!&ndash;          <div class="flow-item-time">11月开始</div>&ndash;&gt;-->
<!--        </div>-->
      </div>


      <div style="margin-top: 40px;font-family: PingFangSC-Medium;font-size: 20px;color: #222222;letter-spacing: 0;text-align: center;font-weight: 500;">
        期待你的加入
      </div>
<!--      <div style="margin-top:8px;margin-left: 20px;margin-right: 20px; font-family: PingFangSC-Regular;font-size: 11px;color: #606266;text-align: center;font-weight: 400;">-->
<!--        技术、产品、内容类职位base北京<br/>-->
<!--        营销类岗位分布于北京、上海、广州、深圳、武汉、成都、重庆、西安等各大城市-->
<!--      </div>-->

      <div style="margin: 20px 10px;">


        <van-grid :gutter="10" :border="false" :column-num="2">
          <van-grid-item :key="k1" v-on:click="gotoDetail('1004')">
              <div style="width: 100%;display: flex;flex-direction: column;justify-content: flex-start;align-items: center;align-content: center">
                <span class="pos-title">应届生招聘</span>
                <div class="zhaopinProjectUnderLine"></div>
                <span class="pos-content" style="margin-top: 20px;font-size: 14px; text-align: center;">2027届JIA STAR家速计划校园招聘</span>
<!--                <span class="pos-tags">2025年9月-2026年8月毕业的同学</span>-->
                <span class="pos-link">查看详情<img style="width: 12px;height: 12px;margin-left: 4px" :src="require('@/assets/toright.png')"  ></span>
              </div>

          </van-grid-item>
          <van-grid-item :key="k2" v-on:click="gotoDetail('1003')">
            <div style="width: 100%;display: flex;flex-direction: column;justify-content: flex-start;align-items: center;align-content: center">
              <span class="pos-title">实习生招聘</span>

              <div class="zhaopinProjectUnderLine"></div>
              <span class="pos-content" style="margin-top: 20px;font-size: 14px; text-align: center;">在校生日常实习</span>
<!--              <span class="pos-tags">面向2027届毕业生，提供转正机会</span>-->
              <span class="pos-link">查看详情<img style="width: 12px;height: 12px;margin-left: 4px" :src="require('@/assets/toright.png')" ></span>
            </div>
          </van-grid-item>
        </van-grid>

      </div>
      <SafeBottom></SafeBottom>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from 'vue';
import Header from "./Header1";
import Footer from "./Footer";
import {
  Toast,
  Grid,
  GridItem,
} from "vant";
import wx from "weixin-js-sdk";
import Utils from "../utils/Utils";
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import SafeBottom from "./SafeBottom";
import qs from "qs";
Vue.use(Grid);
Vue.use(GridItem);
export default {
  name: "Index",
  components:{
    SafeBottom,
    Header,
    Footer
  },
  data(){
    return {
      app:"",
      loading:false,
      list:[],
    }
  },
  mounted: function() {
    this.app = Utils.getApp();
    this.getPostion();
  },
  methods: {
    getPostion(){
      let that=this;
      this.loading=true;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getSchoolRecruitHomePositionList).then(data => {
        that.loading=false;
        Toast.clear();
        if (data) {
          that.list = data;
        }
      });
    },
    gotoIntro(){
      if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url='+encodeURIComponent('/intro'),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/intro'});
      }
    },
    gotoDetail(targetId)
    {
      if(this.app=='WeiXinMini')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url=positionlist&param='+encodeURIComponent("targetId="+targetId),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/positionlist',query:{
            ...qs.parse("targetId="+targetId)
          }});
      }
    },
    gotoPostionList() {
      if(this.app=='WeiXinMini' && this.$route.query.minipage=='m')
      {
        Toast.loading({
          duration: 500,
          forbidClick: true,
        });
        wx.miniProgram.navigateTo({
          url: '/pages/m/child?url='+encodeURIComponent('/positionlist'),
          complete:()=>{
            Toast.clear();
          }
        });
      }
      else
      {
        this.$router.push({path:'/positionlist'});
      }
    },
    escapeSymbol(str){
      if(!str)
      {
        return str;
      }
      return str.replace(/\n/g,'<br>')
          .replace(/\|/g,'<span style="display: inline-block;width: 1px;height: 9px;background-color:#f0f0f0;margin: 0 4px;"></span>');
    }
  }
}
</script>

<style scoped>
.page{
  background-color: #F8F9FC;
  height: 100%;
  flex-direction: column;
  display: flex;
}
.body{
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.intro-box{
  background-color: #FFFFFF;
}
.intro-banner{
  width: 100%;
  object-fit: contain;
}
.intro-pos-btn{
  //background-color: transparent;
  //font-size: 14px;
  //font-family: PingFangSC-Regular;
  //color: #FFFFFF;
  //height: 40px;
  //width: 110px;
  //text-align: center;
  //border: none;
  background-color: #FFFFFF;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  color: #206CFE;
  height: 36px;
  width: 110px;
  text-align: center;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.intro{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #111E36;
  letter-spacing: 0;
  font-weight: 400;
  text-indent:2em;
  padding: 16px;
}
.intro-link{
  margin-top: 16px;
  text-indent:0;
  text-align: center;
}
.intro-link-icon{
  margin-left: 4px;
  width: 12px;
  height: 12px;
  vertical-align: middle;
}
.title{
  margin-top: 10px;
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
  font-weight: 500;
}
.title-sub{
  margin-top: 4px;
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
.flow-box{
  margin: 20px;
  padding: 16px;
  background-color: #FFFFFF;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
}
.flow-item{
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.flow-item-icon
{
  width: 40px;
  height: 40px;
}
.flow-item-nav-icon{
  width: 36px;
  height: 6px;
  margin-top: 16px;
  vertical-align: middle;
  position: absolute;
  left: -18px;
}
.flow-item-title
{
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #222222;
  text-align: center;
  font-weight: 500;
}
.flow-item-time{
  margin-top: 4px;
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #666D7F;
  text-align: center;
  font-weight: 400;
}
.van-grid-item{
  box-shadow: 0px 2px 10px 0px rgba(134, 135, 152, 0.0956);
}
.van-grid-item>>> .van-grid-item__content{
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 20px 16px;
}
.pos-icon{
  width: 90px;
  height: 90px;
}
.pos-title{
  margin: 11px 0;
  height: 20px;
  line-height: 20px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #222222;
  text-align: center;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pos-content{
  height: 36px;
}
.pos-tags{
  max-height: 36px;

  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #666D7F;
  text-align: center;
  font-weight: 400;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pos-workplace
{
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #666D7F;
  text-align: center;
  font-weight: 400;
}
.pos-tags+.pos-workplace{
  margin-top: 5px;
}
.pos-link{
  //margin-top: 16px;
  //font-family: PingFangSC-Regular;
  //font-size: 12px;
  //color: #111E36;
  //font-weight: 400;

  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #206CFE;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 10px;
}
.pos-link-icon{
  margin-left: 4px;
  width: 11px;
  height: 11px;
  vertical-align: middle;
}
.zhaopinProjectTitle {
  font-family: Microsoft YaHei;
  font-size: 28px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0px;
  color: #222222;
}

.zhaopinProjectUnderLine {
  width: 30px;
  height: 0px;
  display: inline-block;
  opacity: 1;
  border: 2px solid #404040;
  margin-top: 5px;
}

.zhaopinProjectSubTitle {
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0px;
  color: #222222;
  margin-top: 40px;
}

.zhaopinProjectRemark {
  font-family: Microsoft YaHei;
  font-size: 12px;
  font-weight: normal;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0px;
  color: #222222;
  margin-top: 8px;
}

.zhaopinViewDetail {
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #206CFE;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 10px;
}
</style>